/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchProfileAvailability } from './';
import {
    SourcingSearchProfileAvailabilityFromJSON,
    SourcingSearchProfileAvailabilityFromJSONTyped,
    SourcingSearchProfileAvailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchAvailabilityInfo
 */
export interface SourcingSearchAvailabilityInfo {
    /**
     * 
     * @type {SourcingSearchProfileAvailability}
     * @memberof SourcingSearchAvailabilityInfo
     */
    availability?: SourcingSearchProfileAvailability;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchAvailabilityInfo
     */
    frequency?: SourcingSearchAvailabilityInfoFrequencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof SourcingSearchAvailabilityInfo
     */
    nextAvailabilityDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchAvailabilityInfo
     */
    nextAvailabilityConfirmation?: boolean;
}


/**
 * @export
 */
export const SourcingSearchAvailabilityInfoFrequencyEnum = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    EveningsAndWeekends: 'EVENINGS_AND_WEEKENDS',
    FullTime: 'FULL_TIME'
} as const;
export type SourcingSearchAvailabilityInfoFrequencyEnum = typeof SourcingSearchAvailabilityInfoFrequencyEnum[keyof typeof SourcingSearchAvailabilityInfoFrequencyEnum];


/**
 * Check if a given object implements the SourcingSearchAvailabilityInfo interface.
 */
export function instanceOfSourcingSearchAvailabilityInfo(value: object): value is SourcingSearchAvailabilityInfo {
    return true;
}

export function SourcingSearchAvailabilityInfoFromJSON(json: any): SourcingSearchAvailabilityInfo {
    return SourcingSearchAvailabilityInfoFromJSONTyped(json, false);
}

export function SourcingSearchAvailabilityInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchAvailabilityInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'availability': json['availability'] == null ? undefined : SourcingSearchProfileAvailabilityFromJSON(json['availability']),
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'nextAvailabilityDate': json['nextAvailabilityDate'] == null ? undefined : (new Date(json['nextAvailabilityDate'])),
        'nextAvailabilityConfirmation': json['nextAvailabilityConfirmation'] == null ? undefined : json['nextAvailabilityConfirmation'],
    };
}

export function SourcingSearchAvailabilityInfoToJSON(value?: SourcingSearchAvailabilityInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'availability': SourcingSearchProfileAvailabilityToJSON(value['availability']),
        'frequency': value['frequency'],
        'nextAvailabilityDate': value['nextAvailabilityDate'] == null ? undefined : ((value['nextAvailabilityDate']).toISOString()),
        'nextAvailabilityConfirmation': value['nextAvailabilityConfirmation'],
    };
}

